import React, { Component } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { IAppActionDispatches, mapAppDispatchToProps } from "../../../redux/actions/app";
import { IAppState, mapAppStateToProps } from "../../../redux/reducers/app";
import { WidgetProps, Widget, Widgets } from "..";
import { ISiteCustomWidget, ISiteContentBlock, getWidgets, ISiteWidget, IEditableWidget } from "../../../models/cms";
import { UITextBlock } from "../../ui/UITextBlock";
import { IImage, getSiteMedia, getSiteMedia2 } from "../../../models/Image";
import ImageEnlarge from "../../ui/Media/ImageEnlarge";
import { UICMSContent } from "../../ui/UICMSContent";
import { WidgetType } from "../../../laco-common/base/models/widget";
import { ImageWithLayersBG } from "../../ui/Media/ImageWithLayersBG";
import "./CustomWidget.scss";

type CustomWidgetProps = IEditableWidget & {
	id: string;
	renderMobileLayout?: boolean;
} & WidgetProps;

class CustomWidget extends Component<IAppActionDispatches & IAppState & CustomWidgetProps> {
	get customWidget(): ISiteCustomWidget {
		return (
			this.props.editWidget ||
			(this.props.customWidgets || []).find((c: ISiteCustomWidget) => c.id === this.props.id)
		);
	}

	// i is the same for text and image
	getOrderClasses(textBlock: ISiteContentBlock, i: number, oddRow: boolean, isImage: boolean): string {
		let desktopOrder = `order-md-${oddRow && isImage ? i + 1 : i}`;
		let mobileOrder = `order-${isImage ? i : i + 1}`;
		if (textBlock.textFirst) {
			desktopOrder = `order-md-${isImage ? i + 1 : i}`;
			mobileOrder = `order-${isImage ? i + 1 : i}`;
		} else if (textBlock.preserveOrderOnMobile) {
			mobileOrder = `order-${i}`;
		}
		return `${mobileOrder} ${desktopOrder}`;
	}

	render() {
		const customWidget: ISiteCustomWidget = this.customWidget;
		if (!this.customWidget) return null;
		const editable: boolean = !!this.props.editWidget;

		return (
			// <div className={clsx(customWidget.bgColor && `bg-${customWidget.bgColor}`)}>
			<div>
				<div
					className={clsx(
						!this.props.isNested && "container",
						!this.props.page?.noPadding && "section-padding",
						"d-flex flex-column"
					)}
				>
					{!!customWidget.title && (
						<h1
							className={clsx("highlighted", editable && "cms-editable-field")}
							contentEditable={editable}
							data-cms-field="title"
							onBlur={this.props.onInput}
						>
							{customWidget.title}
						</h1>
					)}
					{!!customWidget.content && (
						<UICMSContent
							content={customWidget.content}
							onInput={this.props.onInput}
							editable={editable}
							cmsField="content"
						/>
					)}
					{!!customWidget.nestedWidgets && (
						<Widgets
							widgets={customWidget.nestedWidgets.map((widgetType: WidgetType) => {
								return {
									id: undefined,
									widgetType,
								};
							})}
							page={this.props.activePage}
							isNested={true}
						/>
					)}
					{!!customWidget.textBlocks && (
						<div
							className={clsx(
								"text-blocks-container d-flex flex-column flex-md-row flex-wrap justify-content-between align-items-md-center",
								this.props.renderMobileLayout && "render-mobile-layout"
							)}
						>
							{(customWidget.textBlocks || []).map((textBlock: ISiteContentBlock, i: number) => {
								const media: IImage = getSiteMedia(textBlock.media, "media");
								// debugger;
								const oddRow: boolean = i % 2 > 0;
								const mediaClasses = clsx(
									this.getOrderClasses(textBlock, i, oddRow, true),
									textBlock.alignTop && "align-self-start"
								);
								const renderSimple: boolean =
									textBlock.media.renderSimple || textBlock.renderSimpleMedia;
								return (
									<React.Fragment key={i}>
										{!!media &&
											(textBlock.displayImageWLayersBg ? (
												<ImageWithLayersBG
													url={media.url}
													className={clsx(mediaClasses, "w-md-60")}
												/>
											) : (
												<ImageEnlarge
													className={clsx(
														mediaClasses,
														// this.getOrderClasses(textBlock, i, oddRow, true),
														// textBlock.alignTop && "align-self-start",
														i < customWidget.textBlocks.length - 1 &&
															(media.width as any) == "100%" &&
															"mb-6-desktop",
														(media.width as any) !== "100%" &&
															!textBlock.fullWidth &&
															`m${oddRow && !textBlock.textFirst ? "l" : "r"}-4-desktop`,
														i > 1 && i < customWidget.textBlocks.length && "mt-6-desktop",
														textBlock.imageGrow && "flex-md-grow-1"
														// !textBlock.fullWidth && !media && `m${oddRow ? "l" : "r"}-3-desktop`
													)}
													image={media}
													renderSimple={renderSimple}
													width={textBlock.media.width}
													height={textBlock.media.height}
													hideHover={textBlock.media.noFullscreen}
													displayThumb={!renderSimple}
												/>
											))}
										<UITextBlock
											editable={editable}
											cmsField={`textBlocks[${i}]`}
											onInput={this.props.onInput}
											className={clsx(
												this.getOrderClasses(textBlock, i, oddRow, false),
												textBlock.displayImageWLayersBg && "w-md-40 w-image-w-bg",
												// !textBlock.preserveOrderOnMobile &&
												// 	`order-${i} order-md-${oddRow ? i : i + 1}`,
												// textBlock.preserveOrderOnMobile &&
												// 	`order-${i + 1} order-md-${oddRow ? i : i + 1}`,
												textBlock.alignTop && "align-self-start",
												oddRow && "odd-row",
												textBlock.textGrow && "flex-md-grow-1",
												textBlock.imageGrow && "flex-md-shrink-1",
												textBlock.fullWidth && "w-100",
												textBlock.fullWidth &&
													i < customWidget.textBlocks.length - 1 &&
													"mb-6-desktop",
												i > 1 && i < customWidget.textBlocks.length && "mt-6-desktop"
												// !textBlock.fullWidth && !media && `m${oddRow ? "l" : "r"}-3-desktop`
												// && `p${oddRow ? "l" : "r"}-4-desktop`
											)}
											title={textBlock.title}
											isMainHeading={textBlock.isMainHeading}
											desc={textBlock.content}
											iconUrl={textBlock.iconUrl}
											link={{
												url: textBlock.linkUrl,
												display: textBlock.linkText,
												internal: textBlock.isInternalLink,
												buttonLinkType: textBlock.buttonLinkType,
												buttonMarginLeft: textBlock.buttonMarginLeft,
												xlButton: textBlock.xlButton,
											}}
										>
											<Widgets
												widgets={getWidgets(textBlock.widgets)}
												page={null}
												isNested={true}
											/>
										</UITextBlock>
									</React.Fragment>
								);
							})}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default connect<IAppState, IAppActionDispatches, CustomWidgetProps>(
	mapAppStateToProps,
	mapAppDispatchToProps
)(CustomWidget);
